// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-745b8198] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.textarea[data-v-745b8198] {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-large);
  margin-block-start: 6px;
  resize: vertical;
}
.textarea__main-wrapper[data-v-745b8198] {
  position: relative;
}
.textarea--disabled[data-v-745b8198] {
  opacity: 0.7;
  filter: saturate(0.7);
}
.textarea__input[data-v-745b8198] {
  margin: 0;
  padding-inline: 10px 6px;
  width: 100%;
  height: calc(var(--default-clickable-area) * 2);
  font-size: var(--default-font-size);
  text-overflow: ellipsis;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);
  border-radius: var(--border-radius-large);
  cursor: pointer;
}
.textarea__input[data-v-745b8198]:active:not([disabled]), .textarea__input[data-v-745b8198]:hover:not([disabled]), .textarea__input[data-v-745b8198]:focus:not([disabled]) {
  border-width: var(--border-width-input-focused, 2px);
  border-color: var(--color-main-text);
  box-shadow: 0 0 0 2px var(--color-main-background) !important;
}
.textarea__input[data-v-745b8198]:not(:focus, .textarea__input--label-outside)::placeholder {
  opacity: 0;
}
.textarea__input[data-v-745b8198]:focus {
  cursor: text;
}
.textarea__input[data-v-745b8198]:disabled {
  cursor: default;
}
.textarea__input[data-v-745b8198]:focus-visible {
  box-shadow: unset !important;
}
.textarea__input--success[data-v-745b8198] {
  border-color: var(--color-border-success, var(--color-success)) !important;
}
.textarea__input--success[data-v-745b8198]:focus-visible {
  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
.textarea__input--error[data-v-745b8198] {
  border-color: var(--color-border-error, var(--color-error)) !important;
}
.textarea__input--error[data-v-745b8198]:focus-visible {
  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
.textarea__label[data-v-745b8198] {
  position: absolute;
  margin-inline: 12px 0;
  max-width: fit-content;
  inset-block-start: 11px;
  inset-inline: 0;
  color: var(--color-text-maxcontrast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);
}
.textarea__input:focus + .textarea__label[data-v-745b8198], .textarea__input:not(:placeholder-shown) + .textarea__label[data-v-745b8198] {
  inset-block-start: -10px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-main-text);
  background-color: var(--color-main-background);
  padding-inline: 4px;
  margin-inline-start: 8px;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);
}
.textarea__helper-text-message[data-v-745b8198] {
  padding-block: 4px;
  display: flex;
  align-items: center;
}
.textarea__helper-text-message__icon[data-v-745b8198] {
  margin-inline-end: 8px;
}
.textarea__helper-text-message--error[data-v-745b8198] {
  color: var(--color-error-text);
}
.textarea__helper-text-message--success[data-v-745b8198] {
  color: var(--color-success-text);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcTextArea-B46u6ku9.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,+CAA+C;EAC/C,mCAAmC;EACnC,uBAAuB;EACvB,8CAA8C;EAC9C,6BAA6B;EAC7B,4EAA4E;EAC5E,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,oDAAoD;EACpD,oCAAoC;EACpC,6DAA6D;AAC/D;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,iIAAiI;AACnI;AACA;EACE,sEAAsE;AACxE;AACA;EACE,iIAAiI;AACnI;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kNAAkN;AACpN;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;EAC9C,mBAAmB;EACnB,wBAAwB;EACxB,mJAAmJ;AACrJ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-745b8198] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.textarea[data-v-745b8198] {\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-large);\n  margin-block-start: 6px;\n  resize: vertical;\n}\n.textarea__main-wrapper[data-v-745b8198] {\n  position: relative;\n}\n.textarea--disabled[data-v-745b8198] {\n  opacity: 0.7;\n  filter: saturate(0.7);\n}\n.textarea__input[data-v-745b8198] {\n  margin: 0;\n  padding-inline: 10px 6px;\n  width: 100%;\n  height: calc(var(--default-clickable-area) * 2);\n  font-size: var(--default-font-size);\n  text-overflow: ellipsis;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);\n  border-radius: var(--border-radius-large);\n  cursor: pointer;\n}\n.textarea__input[data-v-745b8198]:active:not([disabled]), .textarea__input[data-v-745b8198]:hover:not([disabled]), .textarea__input[data-v-745b8198]:focus:not([disabled]) {\n  border-width: var(--border-width-input-focused, 2px);\n  border-color: var(--color-main-text);\n  box-shadow: 0 0 0 2px var(--color-main-background) !important;\n}\n.textarea__input[data-v-745b8198]:not(:focus, .textarea__input--label-outside)::placeholder {\n  opacity: 0;\n}\n.textarea__input[data-v-745b8198]:focus {\n  cursor: text;\n}\n.textarea__input[data-v-745b8198]:disabled {\n  cursor: default;\n}\n.textarea__input[data-v-745b8198]:focus-visible {\n  box-shadow: unset !important;\n}\n.textarea__input--success[data-v-745b8198] {\n  border-color: var(--color-border-success, var(--color-success)) !important;\n}\n.textarea__input--success[data-v-745b8198]:focus-visible {\n  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n}\n.textarea__input--error[data-v-745b8198] {\n  border-color: var(--color-border-error, var(--color-error)) !important;\n}\n.textarea__input--error[data-v-745b8198]:focus-visible {\n  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n}\n.textarea__label[data-v-745b8198] {\n  position: absolute;\n  margin-inline: 12px 0;\n  max-width: fit-content;\n  inset-block-start: 11px;\n  inset-inline: 0;\n  color: var(--color-text-maxcontrast);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);\n}\n.textarea__input:focus + .textarea__label[data-v-745b8198], .textarea__input:not(:placeholder-shown) + .textarea__label[data-v-745b8198] {\n  inset-block-start: -10px;\n  line-height: 1.5;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-main-text);\n  background-color: var(--color-main-background);\n  padding-inline: 4px;\n  margin-inline-start: 8px;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);\n}\n.textarea__helper-text-message[data-v-745b8198] {\n  padding-block: 4px;\n  display: flex;\n  align-items: center;\n}\n.textarea__helper-text-message__icon[data-v-745b8198] {\n  margin-inline-end: 8px;\n}\n.textarea__helper-text-message--error[data-v-745b8198] {\n  color: var(--color-error-text);\n}\n.textarea__helper-text-message--success[data-v-745b8198] {\n  color: var(--color-success-text);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
